import PropTypes from 'prop-types';

/**
 * Shared propTypes for HeaderActionButtons (mobile breakpoint) and
 * HeaderDesktop. Both render the same action-button strip + download popup
 * at different breakpoints and consume an identical prop contract, so the
 * validation lives here once instead of being duplicated per file.
 */
export const headerActionPropTypes = {
  company: PropTypes.object.isRequired,
  isToggleFinancialDownload: PropTypes.bool,
  linkedInTooltipText: PropTypes.string,
  searchTooltipText: PropTypes.string,
  isSearchDisabled: PropTypes.bool,
  watchlistTooltipContent: PropTypes.node,
  watchlistTooltipPosition: PropTypes.string,
  watchlistTooltipClickable: PropTypes.bool,
  isWatchlistDisabled: PropTypes.bool,
  isInWatchlist: PropTypes.bool,
  downloadTooltipContent: PropTypes.node,
  windowWidth: PropTypes.number,
  downloadPopupProps: PropTypes.object,
  onWebsiteClick: PropTypes.func,
  onLinkedInClick: PropTypes.func,
  onSearchClick: PropTypes.func,
  onWatchlistClick: PropTypes.func,
  onDownloadToggle: PropTypes.func,
  onDownload: PropTypes.func,
  requestBulkExport: PropTypes.func
};
